
import Vue from 'vue'
import { mapper } from '@/stores/store'
import DownloadButton from '@/components/IconButtons/DownloadButton.vue'
import BackButton from '@/components/Buttons/BackButton.vue'
import UploadButton from '@/components/IconButtons/UploadButton.vue'
import Tooltip from '@/components/Tooltip.vue'

export default Vue.extend({
  components: { DownloadButton, BackButton, UploadButton, Tooltip },
  computed: {
    ...mapper([
      'interacting',
      'footerVisible',
      'pickingColor',
      'downloading',
      'controlsScale',
      'isLandscape',
      'isTablet',
      'previewBox',
    ]),
    ...mapper(['uploadTooltip']),
    buttonSize() {
      return 'md'
    },
  },
  methods: {
    ...mapper(['finishEditingDownload', 'finishEditingUpload', 'showFooter', 'showPreviewBox']),
    ...mapper('pin', ['undo']),
    onTogglePreviewBox() {
      this.showPreviewBox(!this.previewBox)
    },
  },
})
